import type { CrowdexUIMessage } from '@crowdex/agent-contracts';
import type { ArtifactListingEntry } from '@crowdex/agent-contracts/api';
import { artifactCard, ConversationAppCard } from '@/features/apps/conversation-cards';
import { artifactOfFile } from '@/features/apps/use-artifact-index';
import { messageChangedFiles } from '@/lib/conversations/message-changes';

/**
 * The artifacts a message created or changed: the conversation's artifacts (from the core's
 * index) holding a file the message's turn created or changed.
 */
export function messageArtifacts(
  message: CrowdexUIMessage,
  artifacts: readonly ArtifactListingEntry[],
): ArtifactListingEntry[] {
  const found = new Map<string, ArtifactListingEntry>();
  for (const file of messageChangedFiles(message)) {
    if (file.status === 'deleted') continue;
    const artifact = artifactOfFile(artifacts, file.path);
    if (artifact !== undefined) found.set(artifact.id, artifact);
  }
  return [...found.values()];
}

/**
 * The artifacts a message created or changed, each as a card of the core's `crowdex/artifact`
 * widget: its type's preview, Open, and the actions of its type and of cards.
 */
export function MessageArtifactCards({
  artifacts,
  message,
  onOpen,
}: {
  artifacts: readonly ArtifactListingEntry[];
  message: CrowdexUIMessage;
  onOpen: (artifact: ArtifactListingEntry) => void;
}) {
  return messageArtifacts(message, artifacts).map((artifact) => (
    <ConversationAppCard
      artifacts={artifacts}
      card={artifactCard(artifact)}
      conversation={artifact.conversation ?? ''}
      key={artifact.id}
      onOpenArtifact={onOpen}
    />
  ));
}
